import React, { useEffect, useState } from 'react';
import "./Analytics.css";
import organization_icon from "../../assets/images/insight-admin.svg";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classnames from 'classnames';
import user_superadmin from "../../assets/images/user_superadmin.svg";
import admincardspatients from "../../../src/assets/images/admin-cards-patients.svg";
import admincardsactions from "../../../src/assets/images/admin-cards-actions.svg";
import admincardsapplications from "../../../src/assets/images/admin-cards-applications.svg";
import organizatio_superadmin from "../../assets/images/organizatio_superadmin.svg";
import support_supperadmin from "../../assets/images/support_supperadmin.svg";
import PatientsGraph from './PatientsGraph';
import ActionsGraph from './ActionsGraph';
import ApplicationGraph from './ApplicationGraph';
import OrganizationGraph from './OrganizationGraph';
import UsersGraph from './UsersGraph';
import SupportGraph from './SupportGraph';
import { getAllCountList } from '../../api/orgnizations';
import { useDispatch, useSelector } from 'react-redux';
import { failed } from '../../utils/Tostify';

function Analytics() {
    const toggle = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };
    const [activeTab, setActiveTab] = useState("1");

    let user = useSelector((state) => state?.userReducer?.user);
    let token = useSelector(state => state.userReducer.token);
    const [isLoading, setIsLoading] = useState(false);
    const [countData, setCountData] = useState();
    const dispatch = useDispatch();

    const getCountList = async () => {
      let res = "";
      try {
        setIsLoading(true);
        const payload = {orgId: localStorage.getItem("currentOrgId"), clinicId : localStorage.getItem("currentHospitalId"),userId : user._id};
        res = await getAllCountList({ values: payload, dispatch, token });
        if (res?.status === "SUCCESS") {
          setCountData(res?.data);
          setIsLoading(false);
        }
      } catch (error) {
        failed(res?.message);
        setIsLoading(false);
      }
    };

    useEffect(()=>{
      getCountList();
    },[]);

    return (
        <>
            <div className='analytics_content'>
                <div className="super-admin-insights_block">
                    <div className="admin-insights d-flex align-items-center insights-bg">
                        <img src={organization_icon} />
                        <h2 className="super-title title-blocks m-0">Insights</h2>
                    </div>
                    <div className='p-4'>
                        <Nav tabs className='gap-3'>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === "1" })} onClick={() => toggle('1')}>
                                    <div className="card-item cards-super d-flex total_patient">
                                        <div className="card-img">
                                            <img src={admincardspatients} alt="" className="user-icon-block" />
                                        </div>
                                        <div className="card-data">
                                            <h3>Patients</h3>
                                            <p className="admin-block-text">{countData?.allPatientCount ? countData?.allPatientCount + "+": 0}</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === '2' })} onClick={() => toggle('2')}>
                                    <div className="card-item cards-super d-flex total_actions">
                                        <div className="card-img">
                                            <img src={admincardsactions} alt="" className="user-icon-block" />
                                        </div>
                                        <div className="card-data">
                                            <h3>Actions</h3>
                                            <p className="admin-block-text">50+</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === '3' })} onClick={() => toggle('3')}>
                                    <div className="card-item cards-super d-flex total_application">
                                        <div className="card-img">
                                            <img src={admincardsapplications} alt="" className="user-icon-block" />
                                        </div>
                                        <div className="card-data">
                                            <h3>Applications</h3>
                                            <p className="admin-block-text">{countData?.allApplicationsCount ? countData?.allApplicationsCount + "+" : 0}</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === '4' })} onClick={() => toggle('4')}>
                                    <div className="card-item cards-super d-flex total_organization">
                                        <div className="card-img">
                                            <img src={organizatio_superadmin} alt="" className="user-icon-block" />
                                        </div>
                                        <div className="card-data">
                                            <h3>Organizations</h3>
                                            <p className="admin-block-text">400+</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === '5' })} onClick={() => toggle('5')}>
                                    <div className="card-item cards-super d-flex total_users">
                                        <div className="card-img">
                                            <img src={user_superadmin} alt="" className="user-icon-block" />
                                        </div>
                                        <div className="card-data">
                                            <h3>Users</h3>
                                            <p className="admin-block-text">230+</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink className={classnames({ active: activeTab === '6' })} onClick={() => toggle('6')}>
                                    <div className="card-item cards-super d-flex total_support">
                                        <div className="card-img">
                                            <img src={support_supperadmin} alt="" className="user-icon-block" />
                                        </div>
                                        <div className="card-data">
                                            <h3>Support</h3>
                                            <p className="admin-block-text">1000+</p>
                                        </div>
                                    </div>
                                </NavLink>
                            </NavItem>
                        </Nav>

                    </div>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                           <PatientsGraph activeTab={activeTab} />
                        </TabPane>
                        <TabPane tabId="2" className="profile_tab_two">
                           <ActionsGraph activeTab={activeTab}/>
                        </TabPane>
                        <TabPane tabId="3" className="profile_tab_two">
                            <ApplicationGraph activeTab={activeTab}/>
                        </TabPane>
                        <TabPane tabId="4" className="profile_tab_two">
                            <OrganizationGraph activeTab={activeTab}/>
                        </TabPane>
                        <TabPane tabId="5" className="profile_tab_two">
                            <UsersGraph activeTab={activeTab}/>
                        </TabPane>
                        <TabPane tabId="6" className="profile_tab_two">
                            <SupportGraph activeTab={activeTab}/>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        </>
    );
}

export default Analytics;
